import React from 'react';

const Footer = () => {
    return <div className="Footer">© Tech Suite Inc 2016-{new Date().getFullYear()}</div>;
};

export default Footer;
